import { BREAKPOINT_DEFINITIONS } from '../../constants/config.js';
import { getBreakpoint } from '../../utilities/getBreakpoint.js';
import { useEventListener } from './useEventListener.js';
import { useState, useEffect, useRef } from 'react-x';

export function useBreakpointChange(effect, pivotBp) {

  const breakpoint = getBreakpoint();
  const [breakpointValue, setBreakpointValue] = useState(breakpoint);
  const largerThenPivotBpRef = useRef(largerThenPivot(breakpoint));

  function checkBreakpoint() {
    const breakpoint = getBreakpoint();
    if (breakpoint !== breakpointValue) {
      largerThenPivotBpRef.current = largerThenPivot(breakpoint);
      setBreakpointValue(breakpoint);
    }
  };

  function largerThenPivot(breakpoint) {
    const breakpointList = Object.keys(BREAKPOINT_DEFINITIONS);
    return breakpointList.indexOf(pivotBp) <= breakpointList.indexOf(breakpoint);
  };

  useEventListener('resize', checkBreakpoint);

  useEffect(() => {
     return effect(breakpoint, largerThenPivotBpRef.current);
  }, [breakpointValue]);

  return [breakpoint, largerThenPivot(breakpoint)];

};